// @flow
/* eslint import/prefer-default-export: 0 */
import color from 'color';
import { first, last, clamp } from 'lodash';

/**
 * [getMixedColor - interpolate between multiple colors]
 * @param colors
 * @param percent [number between 0 and 1 to interpolate between colors]
 */
export function getMixedColor(colors: Array<string>, percent: number): string {
  const clampedPercent = clamp(percent, 0, 1);

  if (clampedPercent === 0) {
    return color(first(colors)).string();
  }

  if (clampedPercent === 1) {
    return color(last(colors)).string();
  }

  const sectorSize = 1 / (colors.length - 1);
  const i = Math.floor(percent / sectorSize);
  const sectorPercent = (percent % sectorSize) / sectorSize;
  return color(colors[i])
    .mix(color(colors[i + 1]), sectorPercent)
    .string();
}
